import styled from 'styled-components'

const CheckBoxGroup = styled.ul`
  display: flex;
  flex-wrap: wrap;
`

export default CheckBoxGroup
